import { render, staticRenderFns } from "./singleBlog.vue?vue&type=template&id=31a99288&scoped=true&"
import script from "./singleBlog.vue?vue&type=script&lang=js&"
export * from "./singleBlog.vue?vue&type=script&lang=js&"
import style0 from "./singleBlog.vue?vue&type=style&index=0&id=31a99288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a99288",
  null
  
)

export default component.exports